module.exports = __webpack_public_path__ + "static/img/struct1.f24e09a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/struct1.jpg
// module id = JFWL
// module chunks = 1